<template>
    <div class="row nav-padding">
        <div class="col-12">
            <!-- Port-In Request Section -->
            <div class="bg-white border rounded p-4 mt-3 shadow-sm">
                <h5 class="text-dark font-weight-bold mb-3">Port-In Request</h5>

                <p class="mb-3">
                    Bring your existing phone numbers to Aloware. Submit a port-in request and our team will guide you through the process.
                    <a
                        class="text-blue font-weight-bold"
                        href="https://support.aloware.com/en/articles/11163875-how-to-port-non-twilio-numbers-into-aloware"
                        target="_blank">
                        Learn More
                    </a>
                </p>

                <p class="mb-3">
                    If your numbers are hosted on Twilio check the <a class="text-blue font-weight-bold" href="https://support.aloware.com/en/articles/9037398-snap-port-support-guide" target="_blank">Snap Port</a> support guide for faster transfers.
                </p>
                <p class="mb-3">
                    For US/Canada local (10DLC) and toll-free (TFN) numbers, submit the required documents to start your port.
                </p>
                <p class="mb-3">You'll need the following documents:</p>
                <ul class="mb-3">
                    <li>Letter of Authorization (LOA) must match the current carrier records</li>
                    <li>List of numbers to port</li>
                    <li>Proof of ownership (invoice or account screenshot)</li>
                    <li>Customer Service Record (CSR) + PIN (for 10DLC only)</li>
                </ul>
                <p class="mb-4">
                    <strong>Note:</strong> Porting typically takes 2–4 weeks. Once complete, your calls and texts will route through Aloware.
                </p>

                <div class="mb-2">
                    <el-button 
                        type="success" 
                        size="large"
                        @click="openPortInForm"
                        class="rounded">
                        Start Port-In Request
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: "number-port",

    computed: {
        ...mapState('cache', ['current_company'])
    },

    data() {
        return {
            app_env: localStorage.getItem('app_env')
        }
    },

    methods: {
        getHubspotPortInFormLink() {
            if (['local', 'dev', 'mde', 'testing', 'staging'].includes(this.app_env)) {
                return `https://5111u.share.hsforms.com/2gWGN3zndR5-Qwg0KnkXsCA`
            }
            return `https://2qfyk.share.hsforms.com/2FMHBOqIrTMS28Jm_C7pd9w`
        },

        openPortInForm() {
            const formUrl = this.getHubspotPortInFormLink()
            window.open(formUrl, '_blank')
        }
    }
}
</script>
